import { CurrencyRupeeIcon } from "@heroicons/react/24/outline";
import { Button, Link } from "@heroui/react";
import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from "@nextui-org/table";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { CreateCommanWay, GetCommanWay, ListCommanWay } from "API/commonApi";
import axios, { AxiosResponse } from "axios";
import { Img, Input } from "components";
import { AwbLabel } from "components/PrintLabels/AwbLabel";
import moment from "moment";
import ViewPickupMail from "pages/Report/ViewPickupMail";
import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import { roles } from "utils/constant";
import { get_file_url } from "utils/lib-utils";

declare global {
  interface Window {
    SEND_WAPP: (num: any, link: any, msg: any) => void;
  }
}

const TrackingAWB = () => {
  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const navigator = useNavigate();

  const [awbNo, setAwbNo] = useState("");
  const [isLabelOpen, setIsLabelOpen] = useState(false);
  const [awbTrackingData, setAwbTrackingData] = useState<any>({
    tracking_data: [],
    bookingDate: "",
    awbData: {},
    bookingData: {},
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const [deliveryDoneInfo, setDeliveryDoneInfo] = useState<any>({});
  const [productList, setProductList] = useState<any>([]);
  const [commentsList, setCommentsList] = useState<any>([]);

  const [showImg, setShowImg] = useState<any>(false);
  const [showVolume, setShowVolume] = useState<any>(false);
  const [showPayPoup, setShowPayPoup] = useState<boolean>(false);
  const [qrRefId, setQrRefId] = useState<any>("");
  const [qrAmount, setQrAmount] = useState<any>("");

  const [payAmount, setPayAmount] = useState<any>("");
  const [payRemark, setPayRemark] = useState<any>("");

  const [canEditBook, setCanEditBook] = useState<any>(false);
  const [userRole, setUserRole] = useState<string>("");

  const [wappNo, setWappNo] = useState<any>("");
  const SEND_WAPP = (num: any, link: any, msg: any) => {
    let pdfPath = BASE_URL;
    if (awbTrackingData?.bookingData?.customer_code) {
      pdfPath += "/invoices_c";
    } else {
      pdfPath += "/invoices";
    }
    pdfPath += `/${awbTrackingData?.awbData?._invoice_no_c_b?.subbranch}/${awbTrackingData?.awbData?._invoice_no_c_b?.invoice_no}.pdf`;
    axios.request({
      url: BASE_URL + `/admin/send-wapp`,
      method: "POST",
      data: {
        mobile: num,
        pdf: pdfPath,
        msg: msg,
      },
    });
    setWappNo("");
    alert("Whatsapp Sent Successfully!");
  };

  React.useEffect(() => {
    const userD = localStorage.getItem("auth") ? JSON.parse(localStorage.getItem("auth")) : {};
    if (Object.keys(userD).length) {
      setUserRole(userD.state.user.roleName);
      if (
        userD.state.user.role_name == 1 ||
        userD.state.user.role_name == 2 ||
        userD.state.user.role_name == 3 ||
        userD.state.user.roleName == "CUSTOMER SERVICE"
      ) {
        setCanEditBook(true);
      }
      if (userD.state.user.roleName == "CUSTOMER") {
        navigator("/");
      }
    }
  }, []);

  const { isFetching, isLoading, refetch } = useQuery(["admin_product_list"], () => ListCommanWay("/admin/product/list", {}, {}), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        setProductList(data.data.data);
      }
    },
    onError: (data) => {},
  });

  const { refetch: commnetsRefetching } = useQuery(
    ["comments_list"],
    () =>
      ListCommanWay(
        "/admin/awbcomment/list",
        {
          awb_id: awbTrackingData?.awbData?.id,
        },
        { include: ["_addedBy"] }
      ),
    {
      keepPreviousData: true,
      enabled: false,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          setCommentsList(data.data.data);
        }
      },
      onError: (data) => {},
    }
  );

  useEffect(() => {
    if (awbTrackingData?.awbData?.id) {
      commnetsRefetching();
    }
  }, [awbTrackingData]);

  const {
    mutate,
    isLoading: isloading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation((awb_no) => GetCommanWay("/admin/proof_of_delivery/track/" + awb_no, {}, {}), {
    onSuccess: (data: any) => {
      console.log(data, data.status == "SUCCESS");
      if (data.status == "SUCCESS") {
        setAwbTrackingData(data.data);
        setDeliveryDoneInfo({});
        if (data.data.tracking_data) {
          try {
            data.data.tracking_data.forEach((t) => {
              if (t.message_code == "Shipment Delivered" || t.message_code == "0 - Shipment Delivered") {
                setDeliveryDoneInfo(t);
              }
            });
          } catch (e) {}
        }
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });
  const handleSubmit = () => {
    setAwbTrackingData({
      tracking_data: [],
      bookingDate: "",
      awbData: {},
      bookingData: {},
    });
    mutate(awbNo);
  };

  useEffect(() => {
    if (searchParams.get("awb")) {
      setAwbNo(searchParams.get("awb"));
      setAwbTrackingData({
        tracking_data: [],
        bookingDate: "",
        awbData: {},
        bookingData: {},
      });
      mutate(searchParams.get("awb"));
    }
  }, [searchParams]);

  const getTRline = (name, value, isEven: any = false) => {
    return (
      <tr className={isEven ? "bg-blue-100" : ""}>
        <td className="text-right pr-5 whitespace-nowrap">{name}</td>
        <td>{value}</td>
      </tr>
    );
  };

  const getTRline2 = (name, value, isEven: any = false) => {
    return (
      <TableRow>
        <TableCell className="text-right pr-5 whitespace-nowrap text-black-900 text-base">{name}</TableCell>
        <TableCell className="text-black-900 text-base">{value}</TableCell>
      </TableRow>
    );
  };

  const getChargeableWeight = (weight, product_code, ll, bb, hh) => {
    ll = Number(ll);
    bb = Number(bb);
    hh = Number(hh);
    let dWeight = (ll * bb * hh) / (product_code == "X" ? 2700 : 5000);
    return Math.max(Number(weight), dWeight);
  };

  const {
    mutate: mutateUpiQr,
    isLoading: isQrLoading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation((data) => CreateCommanWay(data), {
    onSuccess: (data: any) => {
      console.log(data, data.status == "SUCCESS");
      if (data.status == "SUCCESS") {
        let qrRefId = data.data.qrRefId;
        setQrRefId(qrRefId);
        setQrAmount(data.data.amount);
      } else {
        setQrRefId("");
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      setQrRefId("");
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  const {
    mutate: mutatePayStatus,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation((data) => CreateCommanWay(data), {
    onSuccess: (data: any) => {
      console.log(data, data.status == "SUCCESS");
      if (data.data?.status == "SUCCESS") {
        window.location.reload();
      }
      if (data?.status == "SUCCESS") {
        window.location.reload();
      }
    },
    onError: (data: any) => {
      //setQrRefId("");
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  const {
    mutate: mutateComment,
    isLoading: isCommentloading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation((data) => CreateCommanWay(data), {
    onSuccess: (data: any) => {
      console.log(data, data.status == "SUCCESS");
      if (data.status == "SUCCESS") {
        window.location.reload();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  const handleClickComment = () => {
    Swal.fire({
      title: "Post Comment",
      text: "",
      input: "text",
      confirmButtonText: "Save",
      showCancelButton: true,
      inputPlaceholder: "Enter Comment",
      inputAttributes: {
        style: "border: 1px solid gray; border-radius: 8px",
      },
    }).then((x) => {
      if (x.isConfirmed) {
        console.log(x);
        mutateComment({
          url: "/admin/awbcomment/create",
          data: { comment: x.value, awb_id: awbTrackingData?.awbData?.id },
        });
      }
    });
  };

  const handlePayButton = () => {
    setShowPayPoup(true);
    mutateUpiQr({
      url: "/admin/upi/qr-gen",
      data: { invoice: awbTrackingData?.awbData?.invoice_no_c_b },
    });
  };

  const checkPayStatus = () => {
    mutatePayStatus({
      url: "/admin/upi/qr-pay-status",
      data: { traNo: awbTrackingData?.awbData?._invoice_no_c_b?.utrNo },
    });
  };

  const handleManualPayButton = () => {
    setShowPayPoup(true);
    mutatePayStatus({
      url: "/admin/upi/manual-pay",
      data: { invoice: awbTrackingData?.awbData?.invoice_no_c_b, remark: payRemark },
    });
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return (
    <>
      {isPopupOpen && <div className="fixed inset-0 bg-black-900 bg-opacity-50 z-50 flex items-center justify-end p-4">
        <div className=" rounded-lg shadow-xl w-full max-w-5xl max-h-[95vh] overflow-y-auto relative">
          {/* Optional Close Button */}
          <button className="absolute top-3 right-3 text-black-900 bg-white rounded-md hover:text-gray-700" onClick={() => setIsPopupOpen(false)}>
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          {/* Scrollable Content */}
          <div className="pt-2">
            <ViewPickupMail pickup_code={awbTrackingData?.bookingData?.pickup_code || ''} />
          </div>
        </div>
      </div>}

      {isLabelOpen && (
        <AwbLabel
          isLabelOpen={isLabelOpen}
          setIsLabelOpen={setIsLabelOpen}
          awbData={{ ...awbTrackingData?.awbData, _assign_to_booking: awbTrackingData?.bookingData }}
          setAwbData={() => {}}
        />
      )}
      {showPayPoup && (
        <div className="absolute left-0 top-0 w-full h-[100vh] bg-black-900 bg-opacity-20 flex items-center justify-center z-50">
          <div className="rounded-xl border-2 border-primary p-4 bg-white relative">
            <div className="flex items-center justify-between bg-green-600 text-white p-2 rounded-lg">
              <p>Payment</p>
              <button
                className="px-1"
                onClick={() => {
                  setShowPayPoup(false);
                }}
              >
                ✖
              </button>
            </div>

            <div className="mt-4">
              <div className="flex">
                <div className="w-[200px] h-[250px] border rounded-md mr-3 p-2">
                  {isQrLoading ? (
                    <span>Loading....</span>
                  ) : qrRefId == "" ? (
                    <span>Falied To Load</span>
                  ) : (
                    <div>
                      <QRCode
                        value={`upi://pay?pa=AIRFIELD.EXPRESS@icici&pn=AIRFIELD EXPRESS&tr=${qrRefId}&am=${qrAmount}&cu=INR&mc=5411`}
                        className="w-full h-full mb-4"
                      />
                      <Button
                        className="mt-3 bg-green-600 mx-auto px-2 py-1 rounded-md text-white flex items-center justify-between"
                        onPress={checkPayStatus}
                      >
                        Check Status
                      </Button>
                      <p></p>
                    </div>
                  )}
                </div>

                <div className="">
                  <input
                    value={awbTrackingData?.awbData?._invoice_no_c_b?.total_value}
                    disabled
                    type="text"
                    placeholder="amount"
                    className="border rounded-md focus:border-black-900 bg-gray-200"
                  />
                  <br />
                  <input
                    value={payRemark}
                    onChange={(e) => {
                      setPayRemark(e.target.value);
                    }}
                    type="text"
                    placeholder="remark"
                    className="mt-3 border rounded-md focus:border-black-900"
                  />
                  <br />
                  <Button
                    type="button"
                    className="mt-3 bg-green-600 px-2 py-1 rounded-md text-white flex items-center justify-between"
                    onPress={handleManualPayButton}
                  >
                    {<CurrencyRupeeIcon className="h-6 mr-1" />} Pay
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showVolume && (
        <div className="absolute left-0 top-0 w-full h-full bg-black-900 bg-opacity-20 flex items-center justify-center z-20">
          <div className="rounded-xl border-2 border-primary p-4 bg-white relative">
            <div className="flex items-center justify-between bg-primary text-white p-2 rounded-lg">
              <p>Total Weight: {awbTrackingData?.awbData?.weight}</p>
              <button
                className="px-1"
                onClick={() => {
                  setShowVolume(false);
                }}
              >
                ✖
              </button>
            </div>

            <div>
              <table className="table mt-2">
                <tr>
                  <th className="px-2 border-r">Sr.</th>
                  <th className="px-2">Lenght</th>
                  <th className="px-2">Width</th>
                  <th className="px-2">Height</th>
                  <th className="px-2">Weight</th>
                </tr>
                {awbTrackingData?.awbData?.innerItemsJson && awbTrackingData?.awbData?.innerItemsJson != "[]" ? (
                  JSON.parse(awbTrackingData?.awbData?.innerItemsJson).map((i, a) => {
                    return (
                      <tr className="border-t">
                        <td className="px-4 border-r">{a + 1}</td>
                        <td className="px-4">{i.l}</td>
                        <td className="px-4">{i.b}</td>
                        <td className="px-4">{i.h}</td>
                        <td className="px-4">{i.weight}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr className="border-t">
                    <td className="px-4">1</td>
                    <td className="px-4">{awbTrackingData?.awbData?.l}</td>
                    <td className="px-4">{awbTrackingData?.awbData?.b}</td>
                    <td className="px-4">{awbTrackingData?.awbData?.h}</td>
                    <td className="px-4">{awbTrackingData?.awbData?.weight}</td>
                  </tr>
                )}
              </table>
            </div>
          </div>
        </div>
      )}
      <div className="flex flex-col gap-4 px-4 mt-2 font-inter">
        <div className=" border p-2 rounded-2xl">
          <div className="flex gap-2">
            <div>
              <h1 className="text-center mb-4 text-lg font-semibold underline whitespace-nowrap">Courier Details</h1>

              <p>Airway Bill No:</p>
              <h1 className=" text-white bg-primary font-semibold bg-yellow-200- inline-block px-2 py-1 rounded-md">{awbNo}</h1>

              <Button
                color="primary"
                size="sm"
                variant="bordered"
                className="text-base mt-2"
                onPress={() => {
                  setIsLabelOpen(true);
                }}
              >
                Label
              </Button>
              {canEditBook && (
                <Button
                  color="primary"
                  size="sm"
                  variant="bordered"
                  className="text-base mt-2"
                  onPress={() => {
                    navigator("/booking/add", {
                      state: {
                        mode: "edit",
                        data: awbTrackingData.bookingData,
                      },
                    });
                  }}
                >
                  Edit Booking
                </Button>
              )}

              <hr className="my-2" />

              {awbTrackingData.awbData?.invoice_no_c_b && (
                <Link
                  isBlock
                  showAnchorIcon
                  color="primary"
                  target="_blank"
                  rel="noreferrer"
                  href={`${process.env.REACT_APP_BACKEND_URL}/invoices/${awbTrackingData.awbData.subbranch}/${awbTrackingData.awbData._invoice_no_c_b?.invoice_no}.pdf`}
                  underline="always"
                >
                  Invoice View
                </Link>
              )}

              <Link
                isBlock
                showAnchorIcon
                color="primary"
                target="_blank"
                rel="noreferrer"
                href={`/awb/slip?awb=${awbTrackingData.awbData.awb_no}`}
                className="whitespace-nowrap"
                underline="always"
              >
                Consignee Slip
              </Link>

              {(userRole == "Admin" || userRole == "CUSTOMER") && (
                <>
                  <br />
                  <Link
                    isBlock
                    showAnchorIcon
                    color="primary"
                    target="_blank"
                    rel="noreferrer"
                    href={`/awb/slip?awb=${awbTrackingData.awbData.awb_no}&sh=1`}
                    className="whitespace-nowrap"
                    underline="always"
                  >
                    Shipper Slip
                  </Link>
                </>
              )}

              <br />
              <br />
              <Link
                isBlock
                showAnchorIcon
                color={awbTrackingData?.awbData?.parcelPhoto ? "primary" : "foreground"}
                target="_blank"
                rel="noreferrer"
                isDisabled={awbTrackingData?.awbData?.parcelPhoto ? false : true}
                href={awbTrackingData?.awbData?.parcelPhoto && get_file_url(awbTrackingData?.awbData?.parcelPhoto || "#")}
                className="whitespace-nowrap"
                underline="always"
              >
                Shipment Photo
              </Link>
              <br />

              {awbTrackingData.awbData.slipAwbData ? (
                awbTrackingData.awbData.slipAwbData.map((v, i) => {
                  return (
                    <>
                      <br />
                      <a target="_blank" href={`${get_file_url(v.slip_url)}`} className="text-blue-A700 underline">
                        AWB Slip {i + 1}
                      </a>
                    </>
                  );
                })
              ) : (
                <>-</>
              )}

              <br />

              {awbTrackingData.awbData.slipMbagData?.length ? (
                awbTrackingData.awbData.slipMbagData.map((v, i) => {
                  return (
                    <>
                      <br />
                      <a target="_blank" href={`${get_file_url(v.slip_url)}`} className="text-blue-A700 underline">
                        Motherbag Slip {i + 1}
                      </a>
                    </>
                  );
                })
              ) : (
                <>-</>
              )}
            </div>

            <div className="w-full">
              <Table
                isStriped
                isHeaderSticky
                removeWrapper
                className="w-full text-sm text-left text-gray-500 "
                aria-label="collection table"
                classNames={{
                  td: "group-data-[odd=true]/tr:before:bg-blue-100 py-1", // light blue
                  th: "hidden", // Hides table headers
                }}
              >
                <TableHeader style={{ display: "none" }}>
                  <TableColumn>-</TableColumn>
                  <TableColumn>-</TableColumn>
                </TableHeader>
                <TableBody>
                  {getTRline2("Book Date", moment(awbTrackingData.bookingData?.date, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY"), 1)}
                  {getTRline2(
                    "Product",
                    <div>
                      {productList
                        .map((p) => {
                          return p.product_code == awbTrackingData.awbData.prefix ? p.product_name : "";
                        })
                        .join("")}
                    </div>,
                    0
                  )}
                  {getTRline2(
                    "Reference_Code",
                    <a
                      className="text-blue-900 underline underline-offset-2"
                      target="_blank"
                      href={`/pickup/tracking?awb=${awbTrackingData.bookingData.pickup_code}`}
                    >
                      {awbTrackingData.bookingData.pickup_code}
                    </a>,
                    1
                  )}
                  {getTRline2(
                    "City / Pincode",
                    <div className="flex items-center gap-4">
                      <div className="text-center">
                        <b>{awbTrackingData.bookingData.shipper_city}</b> <br />
                        {awbTrackingData.bookingData.shipper_pincode}
                      </div>
                      <b className="text-2xl">⟶</b>
                      <div className="text-center">
                        <b>{awbTrackingData.awbData.destination}</b>
                        <br />
                        {awbTrackingData.awbData.pincode}
                      </div>
                    </div>
                  )}
                  {getTRline2("Product Type", awbTrackingData.awbData.dox_or_non_dox ? "DOX" : "Non-Dox")}
                  {getTRline2(
                    "Client Name",
                    awbTrackingData.bookingData.customer_sh + ` (${awbTrackingData.bookingData.customer_code})`,
                    1
                  )}
                </TableBody>
              </Table>

              <Table
                removeWrapper
                className="w-full text-sm text-left text-gray-500 "
                aria-label="collection table"
                classNames={{
                  td: "group-data-[odd=true]/tr:before:bg-blue-100 py-1", // light blue
                  th: "hidden", // Hides table headers
                }}
              >
                <TableHeader style={{ display: "none" }}>
                  <TableColumn>-</TableColumn>
                  <TableColumn>-</TableColumn>
                </TableHeader>
                <TableBody>
                  {getTRline2(
                    "Shipper",
                    <div className="bg-gray-200 p-2 rounded-md">
                      <b>{awbTrackingData.bookingData.shipper_sh}</b>
                      <br />
                      {awbTrackingData.bookingData.shipper_address}
                    </div>
                  )}
                  {getTRline2(
                    "Consignee",
                    <div className="bg-gray-200 p-2 rounded-md">
                      <b>{awbTrackingData.awbData.consignee}</b>
                      <br />
                      {awbTrackingData.awbData.address}
                    </div>
                  )}
                </TableBody>
              </Table>
            </div>

            <table className="hidden">
              {getTRline("Book Date", moment(awbTrackingData.bookingData?.date, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY"), 1)}
              {getTRline(
                "Product",
                productList
                  .map((p) => {
                    return p.product_code == awbTrackingData.awbData.prefix ? p.product_name : "";
                  })
                  .join(""),
                0
              )}
              {getTRline(
                "Reference_Code",
                <a
                  className="text-blue-900 underline underline-offset-2"
                  target="_blank"
                  href={`/pickup/tracking?awb=${awbTrackingData.bookingData.pickup_code}`}
                >
                  {awbTrackingData.bookingData.pickup_code}
                </a>,
                1
              )}
              {getTRline("From", awbTrackingData.bookingData.shipper_city)}
              {getTRline("To", awbTrackingData.awbData.destination, 1)}
              {getTRline("Product Type", awbTrackingData.awbData.dox_or_non_dox ? "DOX" : "Non-Dox")}
              {getTRline("Client Name", awbTrackingData.bookingData.customer_sh + ` (${awbTrackingData.bookingData.customer_code})`, 1)}
              {getTRline("Shipper Name", awbTrackingData.bookingData.shipper_sh)}
              {getTRline("Shipper Addr", awbTrackingData.bookingData.shipper_address, 1)}
              {getTRline("Consignee Name", awbTrackingData.awbData.consignee)}
              {getTRline("Consignee Addr", awbTrackingData.awbData.address, 1)}
              {getTRline("Origin", awbTrackingData.bookingData.shipper_pincode)}
              {getTRline("Destination", awbTrackingData.awbData.pincode)}
            </table>

            <table>
              {getTRline("Receiver", deliveryDoneInfo.receiver)}
              {getTRline("Relation", deliveryDoneInfo.receiver_relation)}
              {getTRline("Delivery Date", deliveryDoneInfo.updatedAt || deliveryDoneInfo.createdAt)}
              {getTRline("Shipper Mobile", awbTrackingData.bookingData?.shipper_mobile)}
              {getTRline("Consignee Mobile", awbTrackingData.bookingData.customer_code ? "" : awbTrackingData.awbData?.contact_no)}
              {getTRline("MAWB No", awbTrackingData?.awbData?._mother_bag_id?.mawb || "-")}
              {getTRline("Motherbag No", awbTrackingData?.awbData?._mother_bag_id?.mother_bag_code || "-")}
              {/*getTRline("TP ref. No.", awbTrackingData?.awbData?._mother_bag_id?.refNo || "-")*/}
              {getTRline("TP Name", <b>{awbTrackingData?.awbData?.thirdPartyName || "-"}</b>)}
              {getTRline("TP ref. No.", <b>{awbTrackingData?.awbData?.thirdPartyRef || "-"}</b>)}
              {getTRline("Delivery Emp.", deliveryDoneInfo._addedBy?.name)}
              {getTRline(<b>Current Status</b>, awbTrackingData.tracking_data[awbTrackingData.tracking_data.length - 1]?.message_code)}
              {!awbTrackingData?.bookingData?.customer_code &&
                getTRline(
                  <b>Payment Status</b>,
                  awbTrackingData?.awbData?._invoice_no_c_b?.isFullPaid ? (
                    <p className="text-green-700">
                      PAID ({awbTrackingData?.awbData?._invoice_no_c_b?.payStatus == "CASH" ? "CASH" : "UPI"})
                    </p>
                  ) : (
                    <p className="text-red-600">{awbTrackingData?.awbData?._invoice_no_c_b?.payStatus || "PENDING"}</p>
                  )
                )}

              {!awbTrackingData?.bookingData?.customer_code && (
                <tr>
                  <td className="text-right">
                    <input
                      placeholder="Mobile"
                      type="text"
                      value={wappNo}
                      onChange={(e) => {
                        setWappNo(e.target.value);
                      }}
                    />
                  </td>
                  <td>
                    <Button
                      className="bg-green-600 px-2 py-1 rounded-md text-white flex items-center justify-between"
                      onPress={() => {
                        SEND_WAPP(wappNo, "", awbTrackingData?.awbData?.awb_no);
                      }}
                    >
                      Send Whatsapp
                    </Button>
                  </td>
                </tr>
              )}

              {awbTrackingData.tracking_data[awbTrackingData.tracking_data.length - 1]?.message_code.includes("RTO") &&
                getTRline(
                  <b>RTO Awb No.</b>,
                  <a style={{ color: "blue" }} href={`/pod/tracking?awb=${awbTrackingData.awbData?.returnAwb}`}>
                    {awbTrackingData.awbData?.returnAwb}
                  </a>
                )}
            </table>
          </div>
          <div className="flex justify-between mt-2 border-t pt-2">
            <div className="flex gap-8 flex-1">
              {awbTrackingData.awbData.realWeight && (
                <p>
                  Actual Weight: <b>{awbTrackingData.awbData.realWeight} kg</b>
                </p>
              )}
              <p>
                Chargeable Weight:{" "}
                <b>
                  {awbTrackingData.awbData.prefix != "I" && awbTrackingData.awbData.weight}
                  {awbTrackingData.awbData.prefix == "I" &&
                    getChargeableWeight(
                      awbTrackingData.awbData.realWeight,
                      awbTrackingData.awbData.prefix,
                      awbTrackingData.awbData.l,
                      awbTrackingData.awbData.b,
                      awbTrackingData.awbData.h
                    )}{" "}
                  kg
                </b>
              </p>
              <p>
                10_30: <b>{awbTrackingData.awbData.is10_30 ? "YES" : "NO"}</b>
              </p>
              <p>
                Holiday: <b>{awbTrackingData.awbData.holiday ? "YES" : "NO"}</b>
              </p>
            </div>

            <div className="flex-1 flex items-end justify-end">
              <Button
                className="bg-blue-600 px-2 py-1 rounded-md text-white mr-3"
                onPress={() => {
                  setIsPopupOpen(true);
                }}
              >
                Mail
              </Button>
              <Button
                className="bg-blue-600 px-2 py-1 rounded-md text-white mr-3"
                onPress={() => {
                  setShowVolume(true);
                }}
              >
                Show Volume Info
              </Button>

              <Button
                className="bg-blue-600 px-2 py-1 rounded-md text-white mr-3"
                onPress={() => {
                  setShowImg(!showImg);
                }}
              >
                Show Images
              </Button>

              <Button className="bg-secondary1 px-2 py-1 rounded-md text-white mr-3" onPress={handleClickComment}>
                Post Comment
              </Button>

              {!awbTrackingData?.bookingData?.customer_code && (
                <Button
                  className="bg-green-600 px-2 py-1 rounded-md text-white flex items-center justify-between"
                  onPress={handlePayButton}
                >
                  {<CurrencyRupeeIcon className="h-6 mr-1" />} Pay
                </Button>
              )}
            </div>
          </div>
        </div>

        {showImg && (
          <div className="flex gap-4">
            {awbTrackingData.tracking_data[awbTrackingData.tracking_data.length - 1]?.signature && (
              <Img
                className="h-48"
                src={get_file_url(awbTrackingData.tracking_data[awbTrackingData.tracking_data.length - 1]?.signature)}
              />
            )}
            {awbTrackingData.tracking_data[awbTrackingData.tracking_data.length - 1]?.photo && (
              <Img className="h-48" src={get_file_url(awbTrackingData.tracking_data[awbTrackingData.tracking_data.length - 1]?.photo)} />
            )}
          </div>
        )}

        {awbTrackingData.tracking_data.length ? (
          <div className="flex gap-2 flex-wrap border p-2 rounded-2xl pb-8">
            <div className="w-full font-bold underline ">Tracking Details</div>
            <table className={`flex-1 items-center w-auto justify-center`}>
              <tr className="border-y-2 text-left text-blue-800">
                <th>Date time</th>
                <th>Status</th>
                <th>Location</th>
                <th>Employee</th>
                <th>Device</th>
              </tr>
              {awbTrackingData.tracking_data.length &&
                [
                  /*{
                    id: 0,
                    message_code: "Shipment Booked",
                    createdAt: awbTrackingData.bookingDate,
                  },*/
                  ...awbTrackingData.tracking_data,
                ]
                  .sort((a, b) => a.id - b.id)
                  .map((d, i) => (
                    <>
                      <tr className="" key={`track-data-${i}`}>
                        <td>
                          {moment(d.updatedAt).format("DD-MM-YYYY") == "Invalid date"
                            ? d.updatedAt
                            : moment(d.updatedAt, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY HH:mm")}
                        </td>
                        <td>{d.message_code}</td>
                        <td>{d.subbranch?._pincode?._city?.city_name}</td>
                        <td>{d._addedBy ? d._addedBy.name : "-"}</td>
                        <td>{d.isMobile == 1 ? "Mobile" : "Web"}</td>
                      </tr>
                    </>
                  ))}
            </table>
          </div>
        ) : null}

        {commentsList.length ? (
          <div className="flex gap-2 flex-wrap border p-2 rounded-2xl pb-8">
            <div className="w-full font-bold underline ">Comments</div>
            <table className={`flex-1 items-center w-auto justify-center`}>
              <tr className="border-y-2 text-left text-blue-800">
                <th>Date</th>
                <th>Time</th>
                <th>comments</th>
                <th>Employee</th>
              </tr>
              {commentsList.map((d, i) => (
                <>
                  <tr className="" key={`track-data${d.id}`}>
                    <td>{moment(d.createdAt, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY")}</td>
                    <td>{moment(d.createdAt, "DD-MM-YYYY HH:mm:ss").format("HH:mm")}</td>
                    <td>{d.comment}</td>
                    <td>{d._addedBy ? d._addedBy.name : "-"}</td>
                  </tr>
                </>
              ))}
            </table>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default TrackingAWB;
